<template>
	<div :class="parentClass">
		<div :class="subClass"><img src="/images/spinner.svg" class="fa fa-spin spinner"></div>
	</div>
</template>

<script>

export default {

	props: {
		text: {
			type: String,
			default: 'LOADING',
		},
		withInputContainer: {
			type: Boolean,
			default: true,
		},
		fullPage: {
			type: Boolean,
			default: false,
		},
	},

	computed: {

		parentClass() {
			let classes = [];

			if (this.fullPage) {
				classes.push('loader full-page');
			}
			else if (this.withInputContainer) {
				classes.push('loader inline');
			}

			return classes.join(' ');
		},

		subClass() {
			if (this.fullPage) {
				return 'loader-container';
			}

			return '';
		},
	}

};

</script>
